export const Specs = {
  EnableNewWixFooter: 'specs.funnel.EnableNewWixFooter',
  EnableCompanyInfoForWixFooterInBrazil: 'specs.funnel.EnableCompanyInfoInWixFooterForBrazil',
  EnableLegalLinkUS: 'specs.funnel.EnableLegalLinkUS',
};
